<template>
    <app-layout title="Exporteer aanvragen">
        <template #header>
            <page-title title="Exporteer aanvragen" />
        </template>

        <template #pageContent>
            <Form @submitted="postForm" layout="horizontal" class="w-1/2">
                <Input
                    label="Gepland van"
                    name="planned_from"
                    type="date"
                    placeholder="dd-mm-jjjj"
                    v-model="form.planned_from"
                    :error="form.errors.planned_from"
                    layout="vertical"
                />
                <Input
                    label="Gepland t.e.m."
                    name="planned_until"
                    type="date"
                    placeholder="dd-mm-jjjj"
                    v-model="form.planned_until"
                    :error="form.errors.planned_until"
                    layout="vertical"
                />
                <Button text="Exporteren" buttonType="submit" buttonClass="download" :loading="form.processing" />
            </Form>

        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Button from '@/Components/Button.vue'
import Input from '@/Components/Input.vue'
import Form from '@/Components/Form.vue'

import store from '@/store'
import {useForm} from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Input,
        Form,
    },
    props: [],
    setup (props){

        const form = useForm({
            planned_from: null,
            planned_until: null,
        })

        function postForm()
        {
            axios.post(route('requests.export-excel'),
                {
                    planned_from: form.planned_from,
                    planned_until: form.planned_until,
                },
                { responseType: 'blob' }
            )
                .then((response) => {

                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Aanvragen.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                })
                .catch(function (error) {
                    console.log(error)
                });
        }

        return {
            state: store.state,
            ...store,
            form,
            postForm,
        }
    },
}

</script>
